import { useState, useEffect, useContext } from 'react';

import { Link, withRouter } from 'react-router-dom';
import LogoCelciusColor from '../../assets/img/logos/LogoCelciusColor.svg';
import LogoBasic from '../../assets/img/logos/Celsius.svg';
import UserIcon from '~/assets/img/User.svg';
import IconSidebar from '~/assets/img/sidebar/MenuMobile.svg';
import CloseIconSidebar from '~/assets/img/sidebar/Close.svg';
import { MenuMobile } from '~/components/MenuMobile';
import { MenuUserMobile } from '../MenuUserMobile';
import { getUserProfile } from '~/helpers/userProfile';
import {
  RelativeWrapper,
  CloseWrapper,
  ModalNavItems,
  ActionableWrapper,
  Icon,
  Topbar,
  Wrapper,
} from './styles';
import { SearchNewIcon, SpringerLogo } from '~/icons';
import { getUserClientId } from '~/helpers/getClientsHelper';
import { useAuth } from 'react-oidc-context';
import { GlobalSearch } from '../Header/GlobalSearch';
import { ChangeProfile } from '../Header';
import SelectPlataformContext from '~/contexts/selectPlataform';

const MobileNavbar = ({ history }) => {
  const auth = useAuth();
  const [isModalNavItemsOpen, setIsModalNavItemsOpen] = useState(false);
  const [isModalUserOpen, setIsModalUserOpen] = useState(false);
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const [profile] = useState(getUserProfile);
  const me = profile.fullName;
  const { user } = profile;
  const [clientIds, setClientIds] = useState<number[] | null>(null);
  const { selectPlataform } = useContext(SelectPlataformContext);

  const isNewOverview = history?.location.pathname === '/nova-visao-geral';

  const logout = async () => {
    await auth.signoutRedirect({ post_logout_redirect_uri: process.env.REACT_APP_KEYCLOAK_LOGOUT_REDIRECT_URL });
  };

  useEffect(() => {
    if (!isModalUserOpen && !isModalNavItemsOpen) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [isModalUserOpen, isModalNavItemsOpen]);

  useEffect(() => {
    getUserClientId({ profile, setClientIds });
  }, []);
  const celsiusAdmin = clientIds && (clientIds?.filter((item) => (item !== 157 && item !== 158)).length !== 0 || profile.permissions.isAdminSistema);
  const selectedRemoteControl = selectPlataform === '/controle-inteligente';
  return (
    <Wrapper>
      <Topbar isNewOverview={isNewOverview}>
        {
          (isOpenSearch && celsiusAdmin) ? (
            <img src={LogoBasic} alt="basicLogo " />
          ) : (
            <ActionableWrapper onClick={() => setIsModalNavItemsOpen(true)}>
              <Icon src={IconSidebar} alt="user-icon" />
            </ActionableWrapper>
          )
        }
        {
          !isOpenSearch && (
            <>
              {
                (celsiusAdmin && profile.permissions.isPersonaII) && <ChangeProfile isMobile />
              }
              <Link to="/visao-geral">
                {/* 157 - Atacadão
                158 - Carrier */}
                {
                  (celsiusAdmin && !profile.permissions.isPersonaII) && <img src={LogoCelciusColor} alt="logoCelcius " />
                }
                {
                  (clientIds && clientIds?.filter((item) => (item !== 157 && item !== 158)).length === 0 && !profile.permissions.isAdminSistema) && <SpringerLogo color="black" />
                }
              </Link>
            </>
          )
        }
        {
          (isOpenSearch && !(profile.permissions.isPersonaII && selectedRemoteControl)) && (
            <GlobalSearch isMobile setOpenSearch={setIsOpenSearch} />
          )
        }
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {!(profile.permissions.isPersonaII && selectedRemoteControl) && (
            <div onMouseOver={() => {}} onFocus={() => {}} onClick={() => setIsOpenSearch(!isOpenSearch)}>
              <SearchNewIcon />
            </div>
          )}
          <ActionableWrapper onClick={() => setIsModalUserOpen(true)}>
            <Icon src={UserIcon} alt="user-icon" />
          </ActionableWrapper>
        </div>
      </Topbar>
      {(isModalNavItemsOpen || isModalUserOpen) && (
        <ModalNavItems>
          <RelativeWrapper>
            <CloseWrapper
              onClick={() => (isModalNavItemsOpen ? setIsModalNavItemsOpen(false) : setIsModalUserOpen(false))}
            >
              <Icon src={CloseIconSidebar} alt="close-sidebar-icon" />
            </CloseWrapper>
            {isModalNavItemsOpen ? (
              <MenuMobile setIsModalNavItemsOpen={setIsModalNavItemsOpen} />
            ) : (
              <MenuUserMobile setIsModalUserOpen={setIsModalUserOpen} />
            )}
          </RelativeWrapper>
        </ModalNavItems>
      )}
    </Wrapper>
  );
};

const MobileNavbarWrapper = withRouter(MobileNavbar);

export { MobileNavbarWrapper as MobileNavbar };
